export default "https://assets.pclncdn.com/web/next-landing/905bceee73/_next/static/images/cobrand-luxury-only-promo-327e64e0819d336fe759f9be075ebf30.jpg";